/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CustomerDto } from '../../models/customer-dto';
import { CustomerShowResponse } from '../../models/customer-show-response';

export interface PostCustomerCreate$Params {
      body: CustomerDto
}

export function postCustomerCreate(http: HttpClient, rootUrl: string, params: PostCustomerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomerShowResponse>> {
  const rb = new RequestBuilder(rootUrl, postCustomerCreate.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CustomerShowResponse>;
    })
  );
}

postCustomerCreate.PATH = '/v1/customer';
